import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconCheckBoldDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4.182} d="m20.364 6.25-11.5 11.5-5.228-5.227" /></svg></>;
}
export default IconCheckBoldDefault;